var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalCloseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.375 13.4375L30.8125 20L37.375 26.625C38.1875 27.375 38.1875 28.6875 37.375 29.4375C36.625 30.25 35.3125 30.25 34.5625 29.4375L28 22.875L21.375 29.4375C20.625 30.25 19.3125 30.25 18.5625 29.4375C17.75 28.6875 17.75 27.375 18.5625 26.625L25.125 20L18.5625 13.4375C17.75 12.6875 17.75 11.375 18.5625 10.625C19.3125 9.8125 20.625 9.8125 21.375 10.625L28 17.1875L34.5625 10.625C35.3125 9.8125 36.625 9.8125 37.375 10.625C38.1875 11.375 38.1875 12.6875 37.375 13.4375Z",
    fill: "#68507C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseIcon);
export default __webpack_public_path__ + "static/media/modal-close-icon.8ec1f3ed007eba7afb82a309689177d7.svg";
export { ForwardRef as ReactComponent };